import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Colors from '../../../layout/theme/utils/colors';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    uploadArea: {
      border: `2px dashed ${Colors.gray_goose}`,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(4),
      textAlign: 'center',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      '&:hover': {
        borderColor: Colors.blue,
        backgroundColor: Colors.light_blue2,
      },
    },
    uploadIcon: {
      fontSize: 32,
      color: Colors.hint_gray,
      marginBottom: theme.spacing(1),
    },
    uploadText: {
      color: Colors.font_gray,
      marginBottom: theme.spacing(0.5),
    },
    uploadSubtext: {
      color: Colors.hint_gray,
      fontSize: 12,
    },
    fileInput: {
      display: 'none',
    },
    fileInfo: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1.5),
      backgroundColor: Colors.light_gray,
      borderRadius: theme.spacing(0.5),
      marginBottom: theme.spacing(1),
    },
    fileIcon: {
      width: 24,
      height: 24,
      marginRight: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: Colors.blue,
      color: Colors.white,
      borderRadius: 4,
      fontSize: 10,
      fontWeight: 'bold',
    },
    fileDetails: {
      flex: 1,
    },
    fileName: {
      fontWeight: 600,
      color: Colors.almost_black,
    },
    fileSize: {
      fontSize: 12,
      color: Colors.hint_gray,
    },
    textautosizer: {
      width: '-webkit-fill-available',
      borderRadius: theme.spacing(0.5),
      borderColor: Colors.hint_gray,
      color: Colors.dark_gray,
    },
    label: {
      margin: theme.spacing(3, 0, 3, 0),
      fontWeight: 'bold',
      color: Colors.dark_gray,
    },
  }),
);
